import React from "react";
import PageHeader from "./components/PagesHeaderComponent/PageHeader";
import { useLocation, useNavigate } from "react-router-dom/dist";


const LegalnRegInfoCatDetails = () => {
	const location = useLocation();
	const navigate = useNavigate();
	console.log(location)
	const { desc, title, img } = location.state;
	
	
	return (
		<>
			<PageHeader heading={title} />
			<div className="content_wrap">

				<section className='newsDetails'>
					<div className='container'>


						<img alt={title} variant="top" src={img} />

						<h6 className="desc">{desc}</h6>

					</div>
				</section>
				
			</div>

		</>
	);
};

export default LegalnRegInfoCatDetails;
